<template>
  <div class="page">
    <Header title="线下券核销" :show-back="true" :rightHandler="rightHandler">
      <div
        class="verify-button"
        slot="right"
        >
        卡券核销
      </div>
    </Header>

    <div class="functional-area">
      <van-search class="search" v-model="queryParam.assignWorkshopName" show-action placeholder="请输入修理厂名称搜索">
        <template #action>
          <div class="search-btn" @click="queryOfflineCouponList">搜索</div>
        </template>
      </van-search>

      <div class="base-tabs">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          class="tabs-item"
          :class="{ 'tabs-item-active': item.key === activeTabKey }"
          @click.stop="switchTabs(item)"
        >
          <div>{{ item.value }}</div>
        </div>
      </div>
    </div>

    <PullRefresh
      class="pull-refresh"
      :refreshLoading="refreshLoading"
      @refresh="queryOfflineCouponList">
      <van-list
        v-model="pullingUploading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多了"
        @load="onPullingUp('pulling-up')"
        :immediate-check="false">
        <div class="coupon" v-for="(item) in couponList" :key="item.couponId">
          <div class="coupon-content">
            <div class="coupon-info">
              <span>{{ item.assignWorkshopName }}</span>
            </div>
            <div class="coupon-info">
              <span>{{ item.couponCode }}</span>
            </div>
            <div class="triangle-icon" :style="{'background-color': getIconColor(item)}">{{ item.verifyStatusName }}</div>
          </div>
          <div class="coupon-operate">
            <div>
              <span>{{ item.eventName }}</span>
            </div>
            <div>
              <span>{{ parseTime(item.acceptTime, '{y}-{m}-{d} {h}:{i}') }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </PullRefresh>

    <van-dialog class="verify-dialog" v-model="showDialog" show-cancel-button :before-close="beforeClose">
      <div class="title">卡券核销</div>
      <div class="image-upload">
        <!-- <img v-if="fileList[0] && fileList[0].content" :src="getImg()" alt=""> -->
        <van-uploader v-model="fileList" :max-count="1"/>
      </div>
      <div class="image-alert">上传核销凭证</div>
      <div class="verify-coupon">
        <div class="coupon-title">卡券编码：</div>
        <div class="coupon-code"> {{ scanCode ? scanCode : '暂 无 数 据' }} </div>
        <div class="coupon-scan" @click="handleScanCode">
          扫码
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Header from '@/components/header'
import PullRefresh from '@/components/pull-refresh'
import couponApi from '@/api/coupon'
import fileApi from '@/api/file'
import { commonUtils } from '@/utils/common'
export default {
  name: '',
  components: {
    Header,
    PullRefresh
  },
  data () {
    return {
      refreshLoading: false,
      pullingUploading: false,
      finished: false,
      error: false,

      tabList: [
        { key: '02',
          value: '未审核'
        },
        { key: '03',
          value: '审核通过'
        },
        { key: '04',
          value: '审核未通过'
        }
      ],
      activeTabKey: 'all',

      couponStatusFilter: [],
      couponVerifyStatusFilter: [],

      queryParam: {
        page: 1,
        pageSize: 10,
        couponStatus: '', // 线下券状态
        verifyStatus: '', // 审核状态
        assignWorkshopCode: '', // 修理厂编码
        assignWorkshopName: '', // 修理厂名称
        eventName: '' // 活动名称
      },
      pageInfo: {
        totalPages: 1
      },
      couponList: [],
      fileList: [],
      fileId: '',
      showDialog: false,
      scanCode: ''
    }
  },
  created () {
    this.queryOfflineCouponList()
    this.getOfflineCouponVerifyStatusMap()
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
  },
  methods: {
    parseTime: commonUtils.parseTime,

    // 获取线下券map
    getOfflineCouponVerifyStatusMap () {
      let params = {
        name: 'offlineCouponVerifyStatusMap'
      }
      couponApi.getOfflineCouponVerifyStatusMap(params).then((response) => {
        if (response.data.resultCode === '0') {
          this.tabList = response.data.resultData.offlineCouponVerifyStatusMap
          this.tabList.unshift({ key: 'all', value: '全部' })
        }
      })
    },

    // 获取线下券数据
    queryOfflineCouponList (type) {
      // 下拉刷新
      if (type === 'pull-refresh') {
        this.refreshLoading = true
        this.queryParam.page = this.$options.data().queryParam.page
        this.queryParam.pageSize = this.$options.data().queryParam.pageSize
        this.finished = false
      }
      couponApi.queryOfflineCouponList(this.queryParam).then((response) => {
        if (response.data.resultCode === '0') {
          if (type === 'pull-up') {
            this.couponList = this.couponList.concat(response.data.resultData.couponList)
          } else {
            this.couponList = response.data.resultData.couponList
          }
          this.pageInfo = response.data.resultData.pageInfo
          this.refreshLoading = false
          this.pullingUploading = false
        }
      }).catch(() => {
        this.refreshLoading = false
        this.error = true
        this.pullingUploading = false
      })
    },
    // 点击卡券核销
    rightHandler () {
      // console.log('right click')
      this.showDialog = true
    },

    getImg () {
      if (this.fileList[0] && this.fileList[0].content) {
        return this.fileList[0].content
      }
    },
    beforeClose (action, done) {
      if (action === 'cancel') {
        done()
        this.resetInfo()
      }
      if (action === 'confirm') {
        if (!this.fileList[0] || !this.fileList[0].file) {
          this.$toast('请上传核销凭证')
          done(false)
          return
        }
        if (!this.scanCode) {
          this.$toast('请扫描卡券二维码')
          done(false)
          return
        }
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          mask: true,
          message: '上传图片'
        })
        fileApi.uploadFile(this.fileList[0].file).then(response => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            this.fileId = response.data.resultData.fileDTO.fileId
            // this.uploadPhoto(photoFileId)
            this.submit().then(() => {
              this.resetInfo()
              done()
            }).catch(() => {
              done(false)
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    submit () {
      return new Promise((resolve, reject) => {
        let data = {
          documentFileId: this.fileId,
          couponCode: this.scanCode
        }
        couponApi.submitOfflineCoupon(data).then(response => {
          if (response.data.resultCode === '0') {
            this.$toast.success('提交成功')
            // this.showDialog = false
            this.resetInfo()
            resolve()
          } else {
            reject(response.data.resultMsg)
          }
        }).catch((error) => {
          console.log(error)
          this.$toast.success('提交失败')
          reject(error)
        })
      })
    },
    // 扫码
    handleScanCode () {
      console.log('scancode')
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          console.log('res', res)
          console.log('res scanCode', res.resultStr)
          this.scanCode = res.resultStr
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },
    resetInfo () {
      this.fileList = []
      this.fileId = ''
      this.scanCode = ''
    },
    // 切换tab
    switchTabs (item) {
      this.activeTabKey = item.key
      if (item.key === 'all') {
        this.queryParam.verifyStatus = ''
      } else {
        this.queryParam.verifyStatus = item.key
      }
      this.couponList = []
      this.queryOfflineCouponList()
    },

    getIconColor (item) {
      if (item.verifyStatus === 0) {
        return ''
      }
      if (item.verifyStatus === 10) {
        return '#117281'
      }
      if (item.verifyStatus === 20) {
        return '#f93d34'
      }
    },

    // 上拉加载
    onPullingUp () {
      if (this.queryParam.page < this.pageInfo.totalPages) {
        this.queryParam.page += 1
        this.queryOfflineCouponList('pull-up')
      } else {
        this.finished = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 100px;
  // padding-bottom: 70px;
}
.verify-button {
  color: #fff;
}
.functional-area {
  position: fixed;
  top: 46px;
  left: 0;
  right: 0;
  z-index: 10;
  .search-btn {
    color: #117281;
    font-weight: 600;
  }
}
.pull-refresh {
  margin-top: 40px;
  min-height: calc(100vh);
}
.coupon {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 10px;
  min-height: 90px;
  line-height: 20px;
  background-color: #fff;
  border-radius: 10px;
  font-weight: 600;
  color: #117281;
  .coupon-content {
    position: relative;
    width: 100%;
    padding: 10px;
    font-size: 12px;
    word-break: break-word;
    overflow: hidden;
    .coupon-info {
      display: flex;
      justify-content: space-between;
      line-height: 25px;
      // span:nth-child(1) {
      //   width: 50%;
      // }
    }
    .coupon-point {
      display: flex;
      justify-content: space-between;
    }
  }
  .coupon-operate {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 35px;
    padding: 0 20px;
    line-height: 35px;
    font-size: 12px;
    border-top: 1px solid #ccc;
    font-weight: 500;
    .coupon-check {
      display: flex;
      justify-content: space-around;
      background-color: #fff;
      padding-right: 40px;
      div {
        padding-right: 10px;
      }
    }
    span {
      vertical-align: middle
    }
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle
    }
  }
}
.triangle-icon {
  position: absolute;
  right: -18px;
  top: 60px;
  height: 22px;
  width: 110px;
  font-size: 10px;
  font-weight: normal;
  line-height: 22px;
  color: #fff;
  background-color: #909399;
  text-align: center;
  transform-origin: right top;
  transform: rotate(47deg);
}

.base-tabs {
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
}

.tabs-item {
  padding: 0 15px;
  text-align: center;
  box-sizing: border-box;
}

.tabs-item-active {
  color: #117281;
  position: relative;
  font-weight: bold;
  border-bottom: 3px solid #117281;
  // &:after {
  //   content: '';
  //   height: 2px;
  //   width: 50px;
  //   border-radius: 6px;
  //   background-color: #e95504;
  //   position: absolute;
  //   margin-top: 4px;
  //   left: 50%;
  //   margin-left: -26px;
  // }
}
.verify-dialog {
  text-align: center;
  .title {
    padding-top: 20px;
    color: #117281;
    font-size: 18px;
    font-weight: 600;
  }
  .image-upload {
    margin: 0 auto;
    margin-top: 15px;
    text-align: center;
  }
  .image-alert {
    line-height: 30px;
    color: #666;
  }
  .verify-coupon {
    display: flex;
    justify-content: flex-start;
    // align-items: center;
    text-align: left;
    padding: 20px;
    .coupon-title {
      // width: 80px;
      flex-shrink: 0;
    }
    .coupon-code {
      width: 150px;
      // text-decoration: underline;
      // flex-shrink: 0;
      color: #999;
      word-break: break-all;
    }
    .coupon-scan {
      // color: #117281;
      width: 40px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      // font-weight: 600;
      flex-shrink: 0;
      background-color: #117281;
      border-radius: 5px;
      color: #fff;
    }
  }
}
</style>
